import { createAuthClient } from 'better-auth/react'
import {
  emailOTPClient,
  jwtClient,
  magicLinkClient,
} from 'better-auth/client/plugins'

const authURL = process.env.BUN_PUBLIC_BETTER_AUTH_URL ?? ''
const baseURL =
  authURL && !authURL.includes('localhost')
    ? authURL
    : typeof window !== 'undefined'
      ? window.location.origin
      : authURL

export const authClient = createAuthClient({
  baseURL,
  plugins: [emailOTPClient(), jwtClient(), magicLinkClient()],
})
